import React from "react";
import ReactDOM from "react-dom/client";
import Login from "./login"
import Video from "./pages/videos"

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Login />);
